<template lang="html">

  <section id="login">
    <div class="wrapper d-flex align-items-center auth login-full-bg">
      <div class="w-100">
        <div class="col-lg-4 mx-auto">
          <div class="auth-form-dark text-left p-5 border-rad-5px">
            <h2><span class="blue-txt">
              <img src="../../assets/images/dawn.png" width="50"/>
              SELLER</span>DAWN</h2>
            <h3 class="font-weight-light">Login here</h3>
            <form class="m-t-20" @submit.prevent="handleLogin()">
                <div class="form-group">
                  <label for="exampleInputEmail1">Username *</label>
                  <b-form-input 
                  type="text" 
                  class="form-control" 
                  id="exampleInputEmail1" 
                  aria-describedby="input-1-live-feedback" 
                  placeholder="Username" 
                  v-model="$v.user.username.$model" 
                  :state="validateState('username')" ></b-form-input>
                  <i class="mdi mdi-account"></i>
                  <b-form-invalid-feedback
                      id="input-1-live-feedback"
                    >Username is required.</b-form-invalid-feedback>
                </div>
                <div class="form-group">
                  <label for="exampleInputPassword1">Password *</label>
                  <b-form-input 
                  type="password" 
                  class="form-control" 
                  id="exampleInputPassword1" 
                  placeholder="Password" 
                  v-model="$v.user.password.$model" 
                  aria-describedby="input-2-live-feedback" :state="validateState('password')"></b-form-input>
                  <i class="mdi mdi-eye"></i>
                  <b-form-invalid-feedback
                      id="input-2-live-feedback"
                    >Password field is required.</b-form-invalid-feedback>
                </div>
                <div class="m-t-30">
                   <b-overlay
                      :show="busy"
                      rounded
                      opacity="0.6"
                      spinner-small
                      spinner-variant="primary"
                      @hidden="onHidden"
                    >
                  <b-button variant="primary" :disabled="busy" size="lg" block class="btn-fw" type="submit" ref="button">Login</b-button>
                  </b-overlay>
                </div>
                <!-- <div class="mt-3 text-center">
                  <a href="#" class="auth-link text-white">Forgot password?</a>
                </div> -->
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>

</template>

<script lang="js">
import User from '../../models/user';
import { required } from "vuelidate/lib/validators";
export default {
  name: 'login',
  data() {
    return {
      busy: false,
      user: new User('', ''),
      message: '',
    };
  },
  validations: {
    user: {
      username: {required},
      password: {required}
    }
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.user[name];
      return $dirty ? !$error : null;
    },
    handleLogin(){
        
        this.$v.user.$touch();
        if (this.$v.user.$anyError) {
          return;
        }

         if(this.user.username && this.user.password){
           this.busy = true;
            this.$store.dispatch('auth/login', this.user).then(
              () => {
                this.$router.push('/dashboard');
                this.busy = false;
              },
              error => {
                this.busy = false;
                this.message = (error.response && error.response.data) || error.message || error.toString()
                

                this.$toasted.show(error.response.data.message, {
                    type: 'error',
                    position: 'top-center',
                    action: {
                      text: "Cancel",
                      onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                      },
                    },
                    duration: 5000,
                  });
                  
              }
            )
         }

    },
    onHidden() {
        // Return focus to the button once hidden
        this.$refs.button.focus()
      },
  },
  computed: {
        loggedIn() {
          return this.$store.state.auth.status.loggedIn;
        }
      },
  created() {
    if (this.loggedIn) {
      this.$router.push('/dashboard');
    }
  },
}
</script>

<style scoped lang="scss">
  .border-rad-5px{
    border-radius: 5px;
  }
  .blue-txt{
    color: #3eacff;
  }
</style>
